import { render, staticRenderFns } from "./dashboardOrcamentoConsolidado.vue?vue&type=template&id=9c25a41a&"
import script from "./dashboardOrcamentoConsolidado.vue?vue&type=script&lang=js&"
export * from "./dashboardOrcamentoConsolidado.vue?vue&type=script&lang=js&"
import style0 from "./dashboardOrcamentoConsolidado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports